// Iter52.94 · Formato y orden de la pestaña Rentabilidad (solo pantalla).
// Dos decimales fijos en importes y porcentajes, y orden por columna en los
// tres niveles: texto sin distinguir mayúsculas ni acentos, números como
// números, y vacíos o «—» siempre al final.
export const ORDEN_BASE_RENT = {key: 'margen_eur', dir: 'desc'};

export function fmtEUR(v) {
  const n = Number(v || 0);
  return n.toLocaleString('es-ES', {style: 'currency', currency: 'EUR',
    minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export function fmtPct(v) {
  const n = Number(v || 0);
  return `${n.toLocaleString('es-ES', {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
}

const vacio = (v) => v === null || v === undefined || v === '' || v === '—';

export function ordenarRent(filas, key, dir) {
  if (!key || !filas) return filas || [];
  const signo = dir === 'asc' ? 1 : -1;
  return [...filas].sort((a, b) => {
    const A = a[key], B = b[key];
    if (vacio(A) && vacio(B)) return 0;
    if (vacio(A)) return 1;
    if (vacio(B)) return -1;
    const nA = Number(A), nB = Number(B);
    if (!Number.isNaN(nA) && !Number.isNaN(nB)) return (nA - nB) * signo;
    return String(A).localeCompare(String(B), 'es', {sensitivity: 'base'}) * signo;
  });
}

// 1.er clic ascendente · 2.º descendente · 3.º vuelve al orden de siempre.
export function siguienteOrdenRent(prev, campo) {
  if (prev.key !== campo) return {key: campo, dir: 'asc'};
  if (prev.dir === 'asc') return {key: campo, dir: 'desc'};
  return ORDEN_BASE_RENT;
}
